import { Injectable } from "@angular/core";
import { MonthTimetable, TestEvent } from "../models/event.model";

@Injectable({ providedIn: "root" })
export class TimetableService {
  private timetableData: MonthTimetable = {
    Online: [
      {
        date: "",
        name: "M12 + VRNVR04",
        description: "Data Handling Part 2",
        testtype: "4th Verbal Non Verbal Reasoning",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/gcse-mock-test",
          },
        ],
      },

      {
        date: "",
        name: "MR04",
        description: "4th Maths Revision ",
        testtype: "",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/21bcf6b8eb7ad0b84b91d378a7fe2f97",
          },
        ],
      },

      {
        date: "",
        name: "M13 + ECOMP09",
        testtype: "Shapes Area Perimeter 2",
        description: "9th English Comprehension",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/71602ed081aa9c9fb28886dc9a10b6c8",
          },
        ],
      },

      {
        date: "",
        name: "M14 + ECOMP10",
        description: "Maths Algebra Part 2",
        testtype: "10th English Reading Comprehension",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/e276b44a5befb9ca2eda836a2e0989c8",
          },
        ],
      },

      {
        date: "",
        name: "M15 + CW05",
        description: "Maths Working Speed Test (All Topics)",
        testtype: "5th Verbal Non Verbal Reasoning",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/6b30a55c0a757c103de800d908abc32e",
          },
        ],
      },

      {
        date: "",
        name: "MR05",
        description: "5th Maths Revision",
        testtype:
          "Algebra, Probability, Symmetry, Coordinates, Rotation & Reflection, Mean Mode Median Range",
        centers: [
          {
            name: "Online",
            time: "9:00 AM - 6:00 PM",
            url: "https://www.sehyog.co.uk/11plus-help-club/category/11-topic-test/4fb4c835a7d8a3542ae5bce115a9fa99",
          },
        ],
      },
    ],
  };

  getMonths(): string[] {
    return ["Online"];
  }

  getTimetable(): MonthTimetable {
    return this.timetableData;
  }
}
